var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoPublish(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M9 25V7h10v4h4l.002 14H9zM20.414 5H9C7.897 5 7 5.9 7 7v18c0 1.102.897 2 2 2h14c1.103 0 2-.898 2-2V9.586L20.414 5z",
    transform: "translate(-1132 -944) translate(915 936) translate(201) translate(16 8)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 17.586L13.707 16.293 12.293 17.707 15 20.415 19.707 15.707 18.293 14.293z",
    transform: "translate(-1132 -944) translate(915 936) translate(201) translate(16 8)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoPublish);
export default __webpack_public_path__ + "static/media/ico-publish.71fb2d71dabfa6099e51214f71106b0f.svg";
export { ForwardRef as ReactComponent };